import { render, staticRenderFns } from "./searchresult.vue?vue&type=template&id=39754f8b&scoped=true&"
import script from "./searchresult.vue?vue&type=script&lang=js&"
export * from "./searchresult.vue?vue&type=script&lang=js&"
import style0 from "./searchresult.vue?vue&type=style&index=0&id=39754f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39754f8b",
  null
  
)

export default component.exports